import { render, staticRenderFns } from "./FighterPrestigeStats.vue?vue&type=template&id=d2b5bbb6&scoped=true"
import script from "./FighterPrestigeStats.vue?vue&type=script&lang=js"
export * from "./FighterPrestigeStats.vue?vue&type=script&lang=js"
import style0 from "./FighterPrestigeStats.vue?vue&type=style&index=0&id=d2b5bbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b5bbb6",
  null
  
)

export default component.exports